import { userReducer } from "./user";
import { organizationsReducer } from "./organization";
import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import logger from "./middlewares/logger";
import monitorReducerEnhancer from "./enhancers/monitor";
import createSagaMiddleware from "redux-saga";
import { rootSaga } from "../sagas";
import { plansReducer } from "./plans";
import { paymentsReducer } from "./payments";
import { bluePrintReducer } from "./bluePrint";
import { createSiteReducer } from "./createSite";
import { sitesReducer } from "./sites";
import { setStore } from "../../Utils/storeUtils";

export const initialState = {};

const rootReducer = combineReducers({
  organizationsInfo: organizationsReducer,
  users: userReducer,
  plansInfo: plansReducer,
  paymentInfo: paymentsReducer,
  createSiteInfo: createSiteReducer,
  bluePrintInfo: bluePrintReducer,
  sitesInfo: sitesReducer,
});

let store;

export function configureStore() {
  const sagaMiddleware = createSagaMiddleware();
  let middlewareEnhancer;

  if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
    middlewareEnhancer = applyMiddleware(sagaMiddleware);
  } else {
    middlewareEnhancer = applyMiddleware(logger, sagaMiddleware);
  }

  const composedEnhancers = compose(middlewareEnhancer, monitorReducerEnhancer);

  store = createStore(rootReducer, initialState, composedEnhancers);
  setStore(store);

  sagaMiddleware.run(rootSaga);
  return store;
}
